import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "77",
  fill: "none",
  viewBox: "0 0 72 77"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M35.8 22.518 22 31.288l13.8 8.673 13.9-8.673z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-miterlimit": "10",
      d: "M49.7 31.288v17.248l-13.9 8.77-13.8-8.77V31.288M35.8 39.96v17.346"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-miterlimit": "10",
      d: "M18.3 16.476c4.9-3.508 10.9-5.554 17.5-5.554 16.5 0 29.8 12.96 29.8 29.039S52.3 69 35.8 69 6 56.04 6 39.96c0-3.897.8-7.6 2.2-11.01"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      d: "M20.005 8 18 16.95l9.823 1.827"
    }, null, -1)
  ])))
}
export default { render: render }